import { memo } from 'react';
import './style.scss';

const PageBody = memo(({ classNames, children }) => {
	return <div className={`page-body bg-white rounded ${classNames ? classNames : ''}`}>{children}</div>;
});
export default PageBody;
